export const createLocationUrl = (clientId: number, locationId: number): string => {
    return `/c/${clientId}/location/${locationId}`;
};

export const createCageUrl = (clientId: number, locationId: number, cageId: number): string => {
    return `${createLocationUrl(clientId, locationId)}/pen/${cageId}`;
};

/**
 * A pen page URL, pinned to a cohort when one is given.
 *
 * The cage pages scope their requests to the `fg` cohort, which is the only way
 * to open a **closed** one: the pen itself only knows its current occupant.
 *
 * Callers pass the cohort of the pen they are linking *to* — an id from a
 * different pen means nothing there. `undefined` produces the plain URL, which is
 * what happens with the fish-group flag off, so links stay byte-identical to
 * before.
 */
export const createCagePageUrl = (
    clientId: number,
    locationId: number,
    cageId: number,
    page: string,
    fishGroupId?: number
): string => {
    const base = `${createCageUrl(clientId, locationId, cageId)}${page}`;

    return fishGroupId == null ? base : `${base}?fg=${fishGroupId}`;
};

export default { createLocationUrl, createCageUrl, createCagePageUrl };
